import { popupAtom } from "../../popups/popupAtom";
import { layerDefsAtomFamily } from "../layerDefsAtoms";
import { layerCanBeVisibleSelector } from "./layerCanBeVisibleSelector";

export function setLayerVisibility(newVisibility, layerID, set, get) {
  if (!newVisibility) {
    // need to remove the popup if it is becoming invisible
    set(popupAtom, (oldPopup) => {
      if (oldPopup?.layerId === layerID) {
        return null;
      }
      return oldPopup;
    });
  }
  
  const layerCanBeVisible = get(layerCanBeVisibleSelector(layerID));
  if (!layerCanBeVisible) {
    return;
  }

  set(layerDefsAtomFamily(layerID), (oldLayer) => {
    return {
      ...oldLayer,
      layer: applyLayerVisibility(oldLayer.layer, newVisibility),
      overLayers: oldLayer.overLayers?.map((ol) => applyLayerVisibility(ol, newVisibility))
    }
  });
}

const applyLayerVisibility = (mapLayer, newVisibility) => {
  return {
    ...mapLayer,
    layout: {
      ...mapLayer.layout,
      visibility: newVisibility ? "visible" : "none",
    },
  }
}